import './ui.css';
import type { HTMLAttributes, ReactNode } from 'react';
import { Icon, type IconName } from './icons';

export type ChipVariant = 'default' | 'a' | 'b' | 'accent' | 'danger' | 'active';

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: ChipVariant;
  icon?: IconName;
  /** Non-color sheet cue: 'solid' = Sheet A, 'ring' = Sheet B. */
  cue?: 'solid' | 'ring';
  children: ReactNode;
}

export function Chip({ variant = 'default', icon, cue, className, children, ...rest }: ChipProps) {
  const cls = [
    'ui-chip',
    variant !== 'default' && `ui-chip--${variant}`,
    className,
  ].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {cue && <span className={`ui-chip__cue ui-chip__cue--${cue}`} aria-hidden />}
      {icon && <Icon name={icon} size={13} />}
      {children}
    </span>
  );
}

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'accent' | 'muted' | 'danger' | 'warning';
  children: ReactNode;
}

export function Badge({ tone = 'accent', className, children, ...rest }: BadgeProps) {
  const cls = [
    'ui-badge',
    tone !== 'accent' && `ui-badge--${tone}`,
    className,
  ].filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
